import React, { useEffect, useState } from "react";
import orderService from "../../services/OrderLists";
import { useMediaQuery } from "react-responsive";
import {
  Table,
  Spin,
  message,
  Tooltip,
  Avatar,
  Popover,
  Space,
  Typography,
  Tag,
  Button,
  Flex,
  Descriptions,
  Card,
} from "antd";
import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";
import moment from "moment";
import { FilterOutlined } from "@ant-design/icons";
import hierarchyService from "../../services/hierarchyService";
import SearchFilters from "../../page-components/Orders/SearchFilters";
function ClientOrders() {
  const isMobile = useMediaQuery({ query: "(max-width: 768px)" });
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const username = params.get("username");
  const [loading, setLoading] = useState(true);
  const [tasks, setTasks] = useState([]);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 20,
    total: 0,
  });
  const [showFilters, setShowFilters] = useState(false);

  const [filters, setFilters] = useState({});
  const [statusList, setStatusList] = useState({}); // New state for status list
  const [fetchingStatusList, setFetchingStatusList] = useState(false);
  const [subscribers, setSubscribers] = useState([]);
  const [hierarchyData, setHierarchyData] = useState([]);

  const [filtersList, setFiltersList] = useState([]);
  // Generate columns dynamically from first row
  const { Text } = Typography;

  const renderSubscribers = (subscribers) => {
    if (!subscribers || subscribers.length === 0) return "N/A";
    const displayedSubscribers = subscribers.slice(0, 2);
    const remainingSubscribers = subscribers.slice(2);
    return (
      <Avatar.Group maxCount={3}>
        {displayedSubscribers.map((name, index) => (
          <Tooltip key={index} title={name}>
            <Avatar style={{ backgroundColor: "#1890ff" }}>
              {name.charAt(0).toUpperCase()}
            </Avatar>
          </Tooltip>
        ))}
        {remainingSubscribers.length > 0 && (
          <Popover
            content={
              <div>
                {remainingSubscribers.map((name, index) => (
                  <p key={index}>{name}</p>
                ))}
              </div>
            }
            title="Additional Subscribers">
            <Avatar style={{ backgroundColor: "#f56a00" }}>
              +{remainingSubscribers.length}
            </Avatar>
          </Popover>
        )}
      </Avatar.Group>
    );
  };

  const columns = React.useMemo(() => {
    if (!tasks.length) return [];
    // Build the columns array with custom logic for fixed and styled columns
    let dynamicColumns = Object.keys(tasks[0])
      .map((key) => {
        const dynamicTitle = key
          .replace(/_/g, " ")
          .replace(/\b\w/g, (l) => l.toUpperCase());
        switch (key) {
          case "feedback_due":
            return {
              title: dynamicTitle,
              dataIndex: "feedback_due",
              key: "feedback_due",
              width: 120,
              render: (value) => {
                if (value === true) return "Yes";
                if (value === false) return "No";
                return "-";
              },
            };

          case "payment":
            return [
              {
                title: dynamicTitle,
                dataIndex: "budget",
                key: "budget",
                width: 180,
                render: (_, record) => {
                  const payment = record?.payment;
                  if (!payment) return "N/A";
                  const { budget, amount_paid, currency, payment_status } =
                    payment;
                  const statusDotColor = {
                    Full: "green",
                    Partial: "yellow",
                    Unpaid: "red",
                  };
                  return (
                    <Space direction="vertical" size={0}>
                      <Text strong>
                        {!budget ? "N/A" : `${currency} ${budget}`}
                      </Text>
                      <Space>
                        <span
                          style={{
                            display: "inline-block",
                            width: "8px",
                            height: "8px",
                            borderRadius: "50%",
                            backgroundColor:
                              statusDotColor[payment_status] || "gray",
                          }}></span>
                        <Text
                          type={
                            payment_status === "Full"
                              ? "success"
                              : payment_status === "Partial"
                              ? "warning"
                              : "danger"
                          }>
                          {payment_status === "Full"
                            ? "Paid"
                            : payment_status === "Partial"
                            ? "Partial"
                            : "Unpaid"}
                        </Text>
                      </Space>
                    </Space>
                  );
                },
              },
              {
                title: "Amount Paid",
                dataIndex: "amount_paid",
                key: "amount_paid",
                width: 180,
                render: (_, record) => {
                  const { amount_paid, currency } = record?.payment || {};
                  return (
                    <Text>
                      {amount_paid ? `${currency} ${amount_paid}` : "N/A"}
                    </Text>
                  );
                },
              },
            ];
          case "status":
            return {
              title: "Status",
              dataIndex: "status",
              key: "status",
              fixed: "right",
              width: 180,
              align: "center",
              sorter: (a, b) => {
                if ((a.status || "") > (b.status || "")) return 1;
                if ((a.status || "") < (b.status || "")) return -1;
                return 0;
              },
              sortDirections: ["ascend", "descend"],
              render: (text) => {
                const statusColors = {
                  Unassigned: "#F0F0F0",
                  "Assigned to manager": "#C0C0C0",
                  "In Progress": "#D0E4F2",
                  "Quality Check": "#A9C3E0",
                  Completed: "#C8E6C8",
                  Delivered: "#8FCF8F",
                  Rejected: "#E8A0A0",
                  Cancelled: "#A0A0A0",
                  "Cancelled by User": "#A0A0A0",
                  Failed: "#D09090",
                  Feedback: "#C2A892",
                };
                return (
                  <Tag
                    style={{
                      color: "black",
                      fontWeight: 500,
                      minWidth: 120,
                      textAlign: "center",
                      borderRadius: 6,
                      padding: "2px 12px",
                      background: statusColors[text] || "#f5f5f5",
                      border: "1px solid #e0e0e0",
                    }}>
                    {text || "-"}
                  </Tag>
                );
              },
            };
          case "tags":
            return null;
          case "moved_to_fl":
            return {
              title: dynamicTitle,
              dataIndex: "moved_to_fl",
              key: "moved_to_fl",
              width: 150,
              render: (_, record) => {
                const fl = record?.moved_to_fl ? "Yes" : "No";
                // You may want to add popover logic for freelancer details here if needed
                return <Text>{fl}</Text>;
              },
            };

          case "moved_to_fl_team":
            return {
              title: dynamicTitle,
              dataIndex: "moved_to_fl_team",
              key: "moved_to_fl_team",
              render: (text, record) => {
                const movedToTeam = record?.moved_to_fl_team ? "Yes" : "No";
                return <Text>{movedToTeam}</Text>;
              },
            };
          case "is_executive":
            return {
              title: dynamicTitle,
              dataIndex: "is_executive",
              key: "is_executive",
              render: (text, record) => {
                const isExec = record?.is_executive ? "Yes" : "No";
                return <Text>{isExec}</Text>;
              },
            };
          case "subscribers":
            return {
              title: dynamicTitle,
              dataIndex: "subscribers",
              key: "subscribers",
              width: 200,
              render: (subscribers) => renderSubscribers(subscribers),
            };
          default:
            return {
              title: dynamicTitle,
              dataIndex: key,
              key,
              render: (value) => {
                if (
                  value &&
                  (key.toLowerCase().includes("date") ||
                    key.toLowerCase().includes("created_at") ||
                    key.toLowerCase().includes("deadline"))
                ) {
                  return value
                    ? moment(value).local().format("DD-MM-YYYY HH:mm a")
                    : "-";
                }
                if (key === "title" && typeof value === "string") {
                  const words = value.split(" ");
                  const truncated = words.slice(0, 6).join(" ");
                  const isTruncated = words.length > 6;
                  return isTruncated ? (
                    <Tooltip title={value}>{truncated + "..."}</Tooltip>
                  ) : (
                    value
                  );
                }
                if (key === "key" && typeof value === "string") {
                  return (
                    <a
                      href={`/order-management/my-orders/${value}`}
                      style={{ textDecoration: "underline" }}>
                      {value}
                    </a>
                  );
                }
                if (key === "ownership" && typeof value === "string") {
                  return (
                    <Tooltip title={value} placement="top">
                      <Avatar style={{ backgroundColor: "#f56a00" }}>
                        {value
                          .split(" ")
                          .map((n) => n[0])
                          .join("")
                          .toUpperCase()}
                      </Avatar>
                    </Tooltip>
                  );
                }
                return value === null ? "-" : value;
              },
            };
        }
      })
      .flat()
      .filter((column) => column);

    // Fix the 'Key' column to the left if present
    const keyColIdx = dynamicColumns.findIndex(
      (col) => col.dataIndex === "key"
    );
    if (keyColIdx !== -1) {
      dynamicColumns[keyColIdx] = {
        ...dynamicColumns[keyColIdx],
        fixed: "left",
        width: 150,
      };
    }

    // Ensure 'Status' column is the last and fixed to right
    const statusColIdx = dynamicColumns.findIndex(
      (col) => col.dataIndex === "status"
    );
    if (statusColIdx !== -1) {
      const [statusCol] = dynamicColumns.splice(statusColIdx, 1);
      dynamicColumns.push({ ...statusCol, fixed: "right", width: 180 });
    } else {
      // If not present, add a default status column
      dynamicColumns.push({
        title: "Status",
        dataIndex: "status",
        key: "status",
        fixed: "right",
        width: 180,
        align: "center",
        sorter: (a, b) => {
          if ((a.status || "") > (b.status || "")) return 1;
          if ((a.status || "") < (b.status || "")) return -1;
          return 0;
        },
        sortDirections: ["ascend", "descend"],
        render: (text) => {
          const statusColors = {
            Unassigned: "#F0F0F0",
            "Assigned to manager": "#C0C0C0",
            "In Progress": "#D0E4F2",
            "Quality Check": "#A9C3E0",
            Completed: "#C8E6C8",
            Delivered: "#8FCF8F",
            Rejected: "#E8A0A0",
            Cancelled: "#A0A0A0",
                  "Cancelled by User": "#A0A0A0",
            Failed: "#D09090",
            Feedback: "#C2A892",
          };
          return (
            <Tag
              style={{
                color: "black",
                fontWeight: 500,
                minWidth: 120,
                textAlign: "center",
                borderRadius: 6,
                padding: "2px 12px",
                background: statusColors[text] || "#f5f5f5",
                border: "1px solid #e0e0e0",
              }}>
              {text || "-"}
            </Tag>
          );
        },
      });
    }
    return dynamicColumns;
  }, [tasks]);

  const toggleFilters = () => {
    setShowFilters(!showFilters);
  };

  const fetchDropdownList = async () => {
    try {
      const dropdownList = await orderService.getSubscribersDropDown();

      setSubscribers(dropdownList?.data?.data || []);
    } catch (error) {
      console.error("Error fetching dropdown list:", error);
    }
  };

  const fetchStatusList = async () => {
    try {
      setFetchingStatusList(true);
      const response = await orderService.getStatusList();

      if (response) {
        setFetchingStatusList(false);
        const newStatusList = {};
        for (const [key, value] of Object.entries(response.data.data)) {
          newStatusList[value] = parseInt(key);
        }
        setStatusList(newStatusList);
      } else {
        setFetchingStatusList(false);

        console.error("Failed to fetch status list or invalid response format");
        console.error("Response:", response);
      }
    } catch (error) {
      setFetchingStatusList(false);
      console.error("Error fetching status list:", error);
    }
  };
  const fetchTasks = async (page = 1, pageSize = 20) => {
    if (!username) return;
    setLoading(true);
    try {
      // Ensure client_username is set in filters if username param exists
      const filtersWithClient = {
        ...filters,
        ...(username ? { client_username: username } : {}),
      };
      const result = await orderService.fetchOrders(
        null,
        filtersWithClient,
        page,
        pageSize,
        "my-orders"
      );

      if (result.success) {
        setFiltersList(result?.data?.data?.filters);
        setTasks(result.data.data.results);
        setPagination({
          ...pagination,
          total: result?.data?.data?.count || 0,
          current: page,
          pageSize,
        });
      } else {
        message.error("Failed to fetch orders");
      }
    } catch (error) {
      setTasks([]);
      setPagination({ current: 1, pageSize: 20, total: 0 });
      message.error("Error fetching client orders");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDropdownList();
    fetchStatusList();

    if (username) {
      fetchTasks();
      // eslint-disable-next-line
    } else {
      console.log("no username");
    }
  }, [username, filters]);

  const handleTableChange = (pagination) => {
    setPagination({ ...pagination });
    fetchTasks(pagination.current, pagination.pageSize);
  };
  const handleSearchClick = (newFilters) => {
    setFilters(newFilters);
    setPagination({ ...pagination, current: 1 });
  };

  const handleClearSearch = async () => {
    setFilters({});

    // await loadOrders(urgencyFilter, 1);
  };
  return (
    <div style={{ padding: "20px" }}>
      {showFilters && (
        <SearchFilters
          filtersList={filtersList}
          onSearch={handleSearchClick}
          loadOrders={handleClearSearch}
          pagination={pagination}
          statusList={statusList}
          fetchingStatusList={fetchingStatusList}
          subscribers={subscribers}
          setSubscribers={setSubscribers}
          hierarchyData={hierarchyData} // still fine to pass
        />
      )}
      <Flex
        gap={4}
        style={{
          justifyContent: "flex-end",
          margin: showFilters ? "8px" : "6px 0px",
        }}>
        <Button
          type="primary"
          icon={<FilterOutlined />}
          onClick={toggleFilters}
          style={{ background: "#040724", width: "40px", padding: "8px" }}
        />
      </Flex>
      <Spin spinning={loading}>
        {isMobile ? (
          <div style={{ margin: "16px 0px" }}>
            {tasks.length === 0 ? (
              <div style={{ textAlign: "center", color: "#999", padding: 24 }}>
                No orders found.
              </div>
            ) : (
              tasks.map((task, idx) => (
                <Card
                  key={task.key}
                  style={{
                    marginBottom: 16,
                    borderRadius: 10,
                    boxShadow: "0 2px 8px #f0f1f2",
                  }}
                  bodyStyle={{ padding: 16 }}>
                  <Descriptions column={1} size="small" bordered>
                    {Object.keys(task).map((key) => {
                      // Hide "key" as it's shown in title
                      if (key === "key")
                        return (
                          <Descriptions.Item label="Order ID" key={key}>
                            <Link
                              to={`/order-management/my-orders/${task.key}`}>
                              {task.key}
                            </Link>
                          </Descriptions.Item>
                        );
                      // Render using the same logic as in table columns
                      if (key === "feedback_due") {
                        return (
                          <Descriptions.Item label="Feedback Due" key={key}>
                            {task[key] === true
                              ? "Yes"
                              : task[key] === false
                              ? "No"
                              : "-"}
                          </Descriptions.Item>
                        );
                      }
                      if (key === "payment") {
                        const payment = task.payment;
                        if (!payment) return null;
                        const {
                          budget,
                          amount_paid,
                          currency,
                          payment_status,
                        } = payment;
                        const statusDotColor = {
                          Full: "green",
                          Partial: "yellow",
                          Unpaid: "red",
                        };
                        return [
                          <Descriptions.Item label="Budget" key="budget">
                            <span style={{ fontWeight: 600 }}>
                              {!budget ? "N/A" : `${currency} ${budget}`}
                            </span>
                          </Descriptions.Item>,
                          <Descriptions.Item
                            label="Amount Paid"
                            key="amount_paid">
                            {amount_paid ? `${currency} ${amount_paid}` : "N/A"}
                          </Descriptions.Item>,
                          <Descriptions.Item
                            label="Payment Status"
                            key="payment_status">
                            <span
                              style={{
                                display: "inline-block",
                                width: 8,
                                height: 8,
                                borderRadius: "50%",
                                backgroundColor:
                                  statusDotColor[payment_status] || "gray",
                                marginRight: 8,
                              }}></span>
                            <span
                              style={{
                                color:
                                  payment_status === "Full"
                                    ? "green"
                                    : payment_status === "Partial"
                                    ? "#faad14"
                                    : "red",
                                fontWeight: 500,
                              }}>
                              {payment_status === "Full"
                                ? "Paid"
                                : payment_status === "Partial"
                                ? "Partial"
                                : "Unpaid"}
                            </span>
                          </Descriptions.Item>,
                        ];
                      }
                      if (key === "status") {
                        const statusColors = {
                          Unassigned: "#F0F0F0",
                          "Assigned to manager": "#C0C0C0",
                          "In Progress": "#D0E4F2",
                          "Quality Check": "#A9C3E0",
                          Completed: "#C8E6C8",
                          Delivered: "#8FCF8F",
                          Rejected: "#E8A0A0",
                          Cancelled: "#A0A0A0",
                  "Cancelled by User": "#A0A0A0",
                          Failed: "#D09090",
                          Feedback: "#C2A892",
                        };
                        return (
                          <Descriptions.Item label="Status" key="status">
                            <Tag
                              style={{
                                color: "black",
                                fontWeight: 500,
                                minWidth: 120,
                                textAlign: "center",
                                borderRadius: 6,
                                padding: "2px 12px",
                                background:
                                  statusColors[task.status] || "#f5f5f5",
                                border: "1px solid #e0e0e0",
                              }}>
                              {task.status || "-"}
                            </Tag>
                          </Descriptions.Item>
                        );
                      }
                      if (key === "subscribers") {
                        return (
                          <Descriptions.Item
                            label="Subscribers"
                            key="subscribers">
                            {renderSubscribers(task.subscribers)}
                          </Descriptions.Item>
                        );
                      }
                      if (key === "moved_to_fl") {
                        return (
                          <Descriptions.Item
                            label="Moved To FL"
                            key="moved_to_fl">
                            {task.moved_to_fl ? "Yes" : "No"}
                          </Descriptions.Item>
                        );
                      }
                      if (key === "moved_to_fl_team") {
                        return (
                          <Descriptions.Item
                            label="Moved To FL Team"
                            key="moved_to_fl_team">
                            {task.moved_to_fl_team ? "Yes" : "No"}
                          </Descriptions.Item>
                        );
                      }
                      if (key === "is_executive") {
                        return (
                          <Descriptions.Item
                            label="Is Executive"
                            key="is_executive">
                            {task.is_executive ? "Yes" : "No"}
                          </Descriptions.Item>
                        );
                      }
                      if (
                        key === "ownership" &&
                        typeof task.ownership === "string"
                      ) {
                        return (
                          <Descriptions.Item label="Ownership" key="ownership">
                            <Tooltip title={task.ownership} placement="top">
                              <Avatar style={{ backgroundColor: "#f56a00" }}>
                                {task.ownership
                                  .split(" ")
                                  .map((n) => n[0])
                                  .join("")
                                  .toUpperCase()}
                              </Avatar>
                            </Tooltip>
                          </Descriptions.Item>
                        );
                      }
                      if (
                        task[key] &&
                        (key.toLowerCase().includes("date") ||
                          key.toLowerCase().includes("created_at") ||
                          key.toLowerCase().includes("deadline"))
                      ) {
                        return (
                          <Descriptions.Item
                            label={key
                              .replace(/_/g, " ")
                              .replace(/\b\w/g, (l) => l.toUpperCase())}
                            key={key}>
                            {task[key]
                              ? moment(task[key])
                                  .local()
                                  .format("DD-MM-YYYY HH:mm a")
                              : "-"}
                          </Descriptions.Item>
                        );
                      }
                      if (key === "title" && typeof task.title === "string") {
                        const words = task.title.split(" ");
                        const truncated = words.slice(0, 6).join(" ");
                        const isTruncated = words.length > 6;
                        return (
                          <Descriptions.Item label="Title" key="title">
                            {isTruncated ? (
                              <Tooltip title={task.title}>
                                {truncated + "..."}
                              </Tooltip>
                            ) : (
                              task.title
                            )}
                          </Descriptions.Item>
                        );
                      }
                      // Hide tags
                      if (key === "tags") return null;
                      // Default
                      return (
                        <Descriptions.Item
                          label={key
                            .replace(/_/g, " ")
                            .replace(/\b\w/g, (l) => l.toUpperCase())}
                          key={key}>
                          {task[key] === null ? "-" : String(task[key])}
                        </Descriptions.Item>
                      );
                    })}
                  </Descriptions>
                </Card>
              ))
            )}
          </div>
        ) : (
          <Table
            style={{ margin: "16px 0px" }}
            columns={columns}
            dataSource={tasks}
            rowKey={(record) => record.key}
            pagination={{
              ...pagination,
              showSizeChanger: true,
              pageSizeOptions: ["10", "20", "50", "100"],
            }}
            onChange={handleTableChange}
            scroll={{ x: "max-content" }}
          />
        )}
      </Spin>
    </div>
  );
}

export default ClientOrders;
